import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/ClaimDeniedIllustration.tsx
const ClaimDeniedIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "claim-denied.svg",
		alt: t("illustration.imageAlt.claimDenied")
	});
};

//#endregion
export { ClaimDeniedIllustration };